<template>
  <el-dialog fullscreen :visible="isShow" :modal="false" :show-close="false" custom-class="dialog-form">
    <div slot="title" class="dialog-title-container">
      <span class="title-label"><i class="el-icon-document"></i> 角色管理表单</span>
      <i class="el-icon-error" @click="handlerClose"></i>
    </div>
    <el-row class="form-top-btns">
      <!--v-if="formData.creator_fk === currentOperater_fk || editable === '是'"-->
      <el-button type="primary" size="mini" plain round icon="em-icon-save" @click="handlerSave">提交保存</el-button>
      <el-button type="danger" size="mini" plain round icon="el-icon-close" @click="handlerClose">关闭</el-button>
    </el-row>
    <div class="form-container">
      <!--表单-->
      <el-form ref="form" :model="formData" size="mini" label-width="120px">
        <!--字段-->
        <div class="form-main">
          <el-row>
            <el-col :span="6">
              <el-form-item label="角色名称" prop="role_name">
                <el-input placeholder="角色名称" v-model="formData.role_name"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="角色描述" prop="description">
                <el-input placeholder="角色描述" v-model="formData.description"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <!--角色明细-->
        <div class="form-details-group" style="top: 50px">
          <el-row :gutter="10">
            <!--树状列表-->
            <el-col :span="4">
              <el-row :gutter="10" style="height: 100%; padding-bottom: 5px">
                <el-col :span="24">
                  <div class="detail-header">
                    <div class="detail-title">
                      <i class="em-icon-th-list"></i> 角色对应菜单信息
                    </div>
                  </div>
                  <el-tree ref="menuTree" :props="defaultProps" :data="menus" node-key="id" show-checkbox default-expand-all highlight-current :default-checked-keys="defaultCheckedMenuIds" style="position: absolute; top: 30px; right: 5px; bottom: 35px; left: 0; overflow-y: auto;" @node-click="handlerMenuClick"></el-tree>
                </el-col>
              </el-row>
            </el-col>
            <!--List按钮列表-->
            <el-col :span="12">
              <div class="detail-header">
                <div class="detail-title"><i class="em-icon-th-list"></i> 列表页按钮信息</div>
                <el-button-group v-if="selectedMenu.id !== '' && selectedMenu.children.length === 0">
                  <!-- 判断 当前选中的菜单不为空，并且是最后一级菜单时，显示“新增功能按钮”功能 -->
                  <el-button type="warning" size="mini" icon="el-icon-plus" @click="addListBtn('list_page_buttons')">新增功能按钮</el-button>
                </el-button-group>
              </div>
              <div class="el-table-container form-details" style="top: 29px; padding-left: 5px; padding-right: 5px">
                <el-table :data="selectedMenu.list_page_buttons" size="mini" stripe border height="100%" style="width: 100% border:1px solid #d1d1d1" header-row-class-name="list-header-row" row-class-name="list-row">
                  <el-table-column label="操作" width="50" align="center" fixed="left">
                    <template v-slot:default="item">
                      <el-button icon="el-icon-close" size="mini" circle type="danger" @click="delBtnList('list_page_buttons', item.$index)"></el-button>
                    </template>
                  </el-table-column>
                  <el-table-column label="按钮名称" width="100" prop="buttonName" align="center">
                    <template v-slot:default="item">
                      <el-input size="mini" placeholder="按钮名称" v-model="item.row.button_name"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column label="按钮类型" width="100" prop="buttonType" align="center">
                    <template v-slot:default="item">
                      <el-input size="mini" placeholder="按钮类型" v-model="item.row.button_type"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column label="按钮图标" width="150" prop="buttonIcon" align="center">
                    <template v-slot:default="item">
                      <el-input size="mini" placeholder="按钮图标" v-model="item.row.button_icon"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column label="函数名称" width="150" prop="fn" align="center">
                    <template v-slot:default="item">
                      <el-input size="mini" placeholder="函数名称" v-model="item.row.fn"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column label="排序" width="50" prop="sort" align="center">
                    <template v-slot:default="item">
                      <el-input size="mini" placeholder="排序" v-model="item.row.sort"></el-input>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="detail-header">
                <div class="detail-title"><i class="em-icon-th-list"></i> 表单页权限</div>
              </div>
              <div v-if="selectedMenu.id !== '' && selectedMenu.children.length === 0" style="margin-top: 10px;">
                <div>
                  <div style="display: inline-block; width: 210px;">非制单人是否允许编辑表单数据</div>
                  <el-select size="mini" style="width: 70px;" v-model="selectedMenu.view_page_buttons[0].edit_able" placeholder="请选择">
                    <el-option v-for="item in editableArr" :key="item.value" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </div>
                <div style="margin-top: 10px;">
                  <div style="display: inline-block; width: 210px;">非制单人是否允许删除表单数据</div>
                  <el-select size="mini" style="width: 70px;" v-model="selectedMenu.view_page_buttons[0].delete_able" placeholder="请选择">
                    <el-option v-for="item in delableArr" :key="item.value" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </div>
    <!--编辑时，新增或修改明细的表单对话框-->
    <ezz-dialog-all-btns ref="allButtonsForm" :parent="this" />
  </el-dialog>
</template>

<script>
import EzzDialogAllBtns from '@/views/dialogs/GetAllBtns.vue'
export default {
  name: 'RoleDialogForm',
  props: {
    parent: {
      type: Object,
      default: () => null
    }
  },
  data: function () {
    return {
      isShow: false,
      // 默认的表单数据结构
      // 如果是浏览或者编辑，formData的值，取决于loadData方法中，获取到的服务器端返回的结果
      formData: null,
      formEmptyData: {
        id: '',
        role_name: '',
        description: '',
        permisses: [],
        creater_id: '',
        updater_id: ''
      },
      // 当前操作者
      operator_id: sessionStorage.getItem('operator_id'),
      // 树状菜单集合
      menus: [],
      // 默认选中的菜单id集合
      defaultCheckedMenuIds: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      emptyMenu: {
        id: '',
        parent_id: '',
        children: [],
        list_page_buttons: [],
        form_page_buttons: [],
        view_page_buttons: [{
          category: 'V',
          edit_able: '否',
          delete_able: '否'
        }]
      },
      // 当前被点击选中的菜单
      selectedMenu: null,
      emptyButtonData: {
        button_name: '',
        button_type: '',
        button_icon: '',
        category: '',
        fn: '',
        sort: ''
      },
      // 非制单人是否允许编辑
      editableArr: [
        { label: '是', value: '是' },
        { label: '否', value: '否' }
      ],
      // 非制单人是否允许删除
      delableArr: [
        { label: '是', value: '是' },
        { label: '否', value: '否' }
      ],
      editable: this.$store.state.editable,
      delable: this.$store.state.delable
    }
  },
  created: function () {
    // 创建时，设置默认的数据结构，防止页面初始化的时候，没有数据导致报错
    this.selectedMenu = JSON.parse(JSON.stringify(this.emptyMenu))
    this.formData = JSON.parse(JSON.stringify(this.formEmptyData))
  },
  mounted: function () {
  },
  methods: {
    loadData: function () {
      let _this = this
      _this.post(_this.$apis.getRole, { RoleId: _this.formData.id }, function (res) {
        let _json = res.data
        _this.menus = _json.menus
        if (_json.role !== null) {
          _this.formData = _json.role
        } else {
          _this.formData = JSON.parse(JSON.stringify(_this.formEmptyData))
          _this.formData.creater_id = _this.operator_id
        }
        _this.defaultCheckedMenuIds = _json.default_checked_menu_ids
      })
    },
    // 新增权限，通过List中，调用该方法
    addHandler: function () {
      this.formData.id = '0'
      this.loadData()
      this.isShow = true
    },
    editHandler: function (formId) {
      this.formData.id = formId
      this.loadData()
      this.isShow = true
    },
    addListBtn: function (_btnListName) {
      this.$refs.allButtonsForm.open(_btnListName)
    },
    delBtnList: function (_btnListName, _index) {
      let _this = this
      _this.$confirm('确定删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.$delete(_this.selectedMenu[_btnListName], _index)
      }).catch(() => {
        _this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    // 菜单项点击事件，不是菜单前面的checkbox的选中事件
    handlerMenuClick: function (_menu) {
      this.selectedMenu = _menu
      if (_menu.children.length === 0) {
        if (this.selectedMenu.view_page_buttons.length === 0) {
          this.selectedMenu.view_page_buttons = [{
            category: 'V',
            edit_able: '否',
            delete_able: '否'
          }]
        }
      }
    },
    // 关闭事件
    handlerClose: function () {
      let _this = this
      _this.$confirm('确定关闭？', '提示', {})
        .then(_ => {
          _this.isShow = false
          // 关闭的时候，将当前选中的菜单清空处理，防止再次打开页面时，与上次打开页面的数据冲突
          _this.selectedMenu = JSON.parse(JSON.stringify(_this.emptyMenu))
        })
        .catch(_ => {
          return false
        })
    },
    // 保存方法
    handlerSave: function () {
      let _this = this
      let halfCheckedMenus = _this.$refs.menuTree.getHalfCheckedNodes()
      let checkedMenus = _this.$refs.menuTree.getCheckedNodes()
      _this.formData.permisses = halfCheckedMenus.concat(checkedMenus)

      if (_this.validationHandler(_this.formData.role_name)) {
        _this.formData.operator_id = _this.operator_id
        _this.post(_this.$apis.saveRole, _this.formData, function (res) {
          let _json = res.data
          if (_json.status === 'ok') {
            _this.$message({
              message: '保存成功',
              type: 'success'
            })
            _this.isShow = false
            // 关闭的时候，将当前选中的菜单清空处理，防止再次打开页面时，与上次打开页面的数据冲突
            _this.selectedMenu = JSON.parse(JSON.stringify(_this.emptyMenu))
            _this.parent.loadData()
          }
        })
      }
    },
    // 验证
    validationHandler: function (roleName) {
      let _this = this
      if (roleName === '') {
        _this.$message({
          type: 'error',
          message: '角色名称不能为空'
        })
        return false
      }

      return true
    }
  },
  components: {
    EzzDialogAllBtns
  }
}
</script>
